angular.module('impactx.item').controller('ItemPriceCtrl', [
    '$scope',
    'TranslationService',
    'ProductEuelService',
    ItemPriceCtrl]);

function ItemPriceCtrl($scope, TranslationService, ProductEuelService) {
    $scope.productDataSheetLabel = TranslationService.get("productDataSheet");
    this.productEuelService = ProductEuelService;
}